import { render, staticRenderFns } from "./CarteiraVacinacaoTableSimple.vue?vue&type=template&id=6d80a8a8&scoped=true&"
import script from "./CarteiraVacinacaoTableSimple.vue?vue&type=script&lang=js&"
export * from "./CarteiraVacinacaoTableSimple.vue?vue&type=script&lang=js&"
import style0 from "./CarteiraVacinacaoTableSimple.vue?vue&type=style&index=0&id=6d80a8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80a8a8",
  null
  
)

export default component.exports